import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { productCategoryDto } from "src/app/model/category/productCategoryDto";
import { API_BASE_PRODUCTSERVICE, API_MAP } from "src/environments/api";

@Injectable()
export class CategoryService {
  public categories$ = new BehaviorSubject<productCategoryDto[]>([]);

  private loadCategoriesRecallCount = 0;

  constructor(private http: HttpClient) {
    this.loadCategories();
}

  loadCategories(): Promise<productCategoryDto[]> {
    const url = API_BASE_PRODUCTSERVICE + API_MAP['products']['GETCATEGORIES'];
    return new Promise((resolve, reject) => {
      this.http.get<productCategoryDto[]>(url).subscribe({
        next: (categories) => {
          this.categories$.next(categories); 
          resolve(categories); 
        },
        error: (err) => {
          this.loadCategoriesRecallCount++;
          if(this.loadCategoriesRecallCount < 5 && err.status === 401)
            setTimeout(() => this.loadCategories(), 1000);
          reject(err);
        }
      });
    });
  }

  createCategory(name: string, value: number): Promise<productCategoryDto> {
    const url = API_BASE_PRODUCTSERVICE + API_MAP['products']['POSTCATEGORY'];
    const currentCategories = this.categories$.value;
    const nextValue =
      currentCategories.length === 0
        ? 1
        : Math.max(...currentCategories.map(c => c.value)) + 1;
  
    const body: productCategoryDto = {id: null, name, value: nextValue, filterOption: false, position: null};
  
    return this.http.post<productCategoryDto>(url, body).toPromise();
  }

  get categories(): Observable<productCategoryDto[]> {
    return this.categories$.asObservable();
  }

  getCategoryByName(name: string): productCategoryDto | undefined {
    return this.categories$.value.find(cat => cat.name === name);
  }

  updateFilterOption(id: number, filterOption: boolean): Promise<productCategoryDto> {
    const url = `${API_BASE_PRODUCTSERVICE}/products/productCategories/${id}/filterOption`;
    const body = { filterOption }; 
    return this.http.patch<productCategoryDto>(url, body).toPromise();
  }

  /**
   * ✅ Updates the positions of all categories
   */
  updateCategoryPositions(categories: productCategoryDto[]): Promise<productCategoryDto[]> {
    const url = API_BASE_PRODUCTSERVICE + API_MAP['products']['PUTPOSITIONS'];
    return this.http.put<productCategoryDto[]>(url, categories).toPromise();
  }

}